







import Vue from 'vue';
import util from '@/utils';
import { Component } from 'vue-property-decorator';
import { getActivationList } from '@/api/school';
import { State } from 'vuex-class';
const namespace = 'user';
@Component({
  components: {
    search: () => import('./components/search.vue'),
    list: () => import('./components/list.vue')
  }
})
export default class Equipment extends Vue {
  @State('orgId', { namespace }) orgId!: string;
  private options: any = {
    pageSize: 20,
    currentPage: 1
  }
  private activationList: any = {}

  private activated() {
    this.handleOptions({orgId: this.orgId})
    this.getActivationList()
  }
  private async getActivationList() {
    try {
      this.activationList = await getActivationList(this.options);
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private handleOptions(opts: any) {
    this.options = { ...this.options, ...opts }
  }
}
